/**
 * @architecture-header 1
 * @layer module
 * @domain assistants
 * @responsibility Choose which assistant answers a run, defaulting to the teacher's default persona.
 * @state-owner caller owns the selection
 * @allowed-imports React; dataset store; shared hooks; module model
 * @forbidden direct API client; persona mutations
 * @public-api activities assignment dialog
 * @side-effects none
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { useDatasetStore } from '../../../shared/model/dataset-store';
import { useTranslator } from '../../../shared/model/use-workspace';
import { assistantSummary, defaultAssistant } from '../model/assistant';

export function AssistantPicker({
  onSelect,
  selectedId,
}: {
  onSelect: (assistantId: string) => void;
  selectedId: string | null;
}) {
  const t = useTranslator();
  const assistants = useDatasetStore((state) => state.assistants);
  const fallback = defaultAssistant(assistants);
  const active = selectedId ?? fallback?.id ?? '';

  return (
    <div className="aspick">
      {assistants.map((assistant) => (
        <button
          className={`aspk ${assistant.id === active ? 'on' : ''}`}
          key={assistant.id}
          type="button"
          onClick={() => onSelect(assistant.id)}
        >
          <span className="asie" style={{ ['--accent' as string]: assistant.accent }}>
            {assistant.emoji}
          </span>
          <span className="asit">
            <b>
              {assistant.name}
              {assistant.isDefault ? <em className="asbadge">{t('預設')}</em> : null}
            </b>
            <span>{assistant.tagline || assistantSummary(assistant)}</span>
          </span>
        </button>
      ))}
    </div>
  );
}
